class CupomKitUpsell extends HTMLElement {
  constructor() {
    super();

    this.config = {
      discount: parseFloat(this.getAttribute("data-upsell-kits-discount")),
      message: this.getAttribute(`data-upsell-kits-message`),
    };
    this.productPrice = 0;
    this.productId = 0;
    this.kitSelectedProductHandle = this.getAttribute("data-kit-selected-product-handle");
    this.kitItemQuantity = Number(this.getAttribute("data-kit-item-quantity") ?? 0);
    this.productKitInfo = 0;
    this.variantValue = 0;
    this.productVariantPrice = 0;

    // Messages
    this.message = this.querySelector("p.message");
    this.discountedPrice = this.querySelector(".discounted-price");

    // Handle price groups
    this.havePriceGroups = this.dataset.havePriceGroups === "true";
    if (this.havePriceGroups) this.productHandle = this.dataset.productHandle;

    this.init();
  }

  /* Start price group handling */
  initGroupPrices() {
    try {
      const productHandle = this.productHandle;
      // check if price group cookies are set
      const priceGroupCookie = this.getPriceGroupCookie(productHandle);

      if (priceGroupCookie === "loading" || !priceGroupCookie) return this.setupPriceGroupListeners();
      if (priceGroupCookie.groupId === "default") return;

      this.priceAdjustment = priceGroupCookie.priceAdjustment;
      this.markdownAdjustment = priceGroupCookie.markdownAdjustment;

    } catch (e) {
      console.error(">>>", e);
      this.priceAdjustment = 0;
    }
  }

  setupPriceGroupListeners() {
    document.addEventListener(`${this.productHandle}-price-group-loaded`, ({ detail }) => {
      this.priceAdjustment = detail.priceAdjustment;
      this.markdownAdjustment = detail.markdownAdjustment;
      this.init();
    });
  }

  getPriceGroupCookie(productHandle) {
    const cookieName = `statsig-group-${productHandle}`;
    const cookieValue = document.cookie
      .split("; ")
      .find((row) => row.startsWith(cookieName))
      ?.split("=")[1];

    if (cookieValue === "loading") return "loading";
    if (!cookieValue) return null;
    return JSON.parse(cookieValue);
  }
  /* End price group handling */

  init() {
    if (this.havePriceGroups) this.initGroupPrices();
    this.productId = parseInt(this.getAttribute("data-upsell-kits-product-id"));
    this.productPrice = parseInt(this.getAttribute("data-upsell-kits-product-price"));
    this.productKitInfo = this.getAttribute("data-upsell-kits-kit-info");
    this.variantValue = parseInt(this.getAttribute("data-upsell-loaded-variant"));

    // wait for price group if it's loading
    if (this.priceAdjustment == undefined && this.havePriceGroups) return;    

    let show;
    if (this.productKitInfo) {
      let productKit = this.productKitInfo.split("|");
      let arrayProduct = [],
        arrayQuantity = [];
      let quantity = 0;
      productKit.forEach((productWithQuantity) => {
        productWithQuantity.split(":").forEach((element, index) => {
          if (index === 0) {
            arrayProduct.push(element);
          } else {
            arrayQuantity.push(element);
          }
        });
      });

      let isEqual = true;
      let firstElement = arrayProduct[0];

      for (let i = 1; i < arrayProduct.length; i++) {
        if (arrayProduct[i] != firstElement) {
          isEqual = false;
          break;
        }
      }

      if (isEqual) {
        arrayQuantity.forEach((element) => {
          quantity += parseInt(element);
        });
      }
      show = this.initPriceText(isEqual, quantity);
    } else {
      show = this.initPriceText(false, 0);
    }
  }

  initPriceText(isEqual, quantity) {
    try {
      if (this.config && this.config.message && this.config.discount && this.productPrice > 0) {
        const upsellButtons = this.parentElement.parentElement.querySelectorAll(".upsell-kits__button");
        let buttonsKits = [];

        upsellButtons.forEach((button, index) => {
          if (index === 0) {
            const buttonFirst = button;
            const variantWithAdjustment = this.priceAdjustment
              ? this.variantValue + this.priceAdjustment
              : this.variantValue;
            const variantValue = variantWithAdjustment * (1 - this.config.discount / 100);

            buttonFirst.querySelector(".discounted-price").innerHTML = this.formatMoneyCountdown(variantValue) + "/un";
          } else {
            buttonsKits.push(button);
          }
        });

        buttonsKits.forEach((buttonKit) => {
          let discount = buttonKit.getAttribute("data-upsell-kits-discount");
          discount = discount * 0.01;
          const variantWithKitDiscount = this.variantValue - this.variantValue * discount;
          const variantWithAdjustment = this.priceAdjustment
            ? variantWithKitDiscount + this.priceAdjustment
            : variantWithKitDiscount;
          const variantWithCupomDiscount = variantWithAdjustment * (1 - this.config.discount / 100);

          buttonKit.querySelector(".discounted-price").innerHTML =
            this.formatMoneyCountdown(variantWithCupomDiscount) + "/un";
        });

        return true;
      }
    } catch (error) {
      console.log("Error: show countdown message");
      console.log(error);
      return false;
    }
  }

  formatMoney(cents) {
    const value = Math.round(cents / 100)
      .toFixed(2)
      .replace(".", ",");
    return `R$ ${value.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
  }

  formatMoneyCountdown(price) {
    const priceNoDecimals = this.formatMoney(price).split(",")[0];
    const priceDisplay = `R$${priceNoDecimals.split("$")[1]}`;

    return priceDisplay;
  }

  findPercentageDiscount(originalPrice, kitPrice) {
    return 100 - (kitPrice * 100) / originalPrice;
  }

  updatePriceText(variant) {
    if (!variant || !variant.price) return;
    this.productPrice = variant.price;

    if (this.config && this.config.message && this.config.discount && this.productPrice > 0) {
      const upsellButtons = this.discountedPrice.parentElement.parentElement.querySelectorAll(".upsell-kits__button");

      let buttonFirst,
        buttonsKits = [];

      upsellButtons.forEach((button, index) => {
        if (index === 0) {
          buttonFirst = button;

          const variantPriceWIthAdjustment = this.priceAdjustment
            ? variant.price + this.priceAdjustment
            : variant.price;
          const price = variantPriceWIthAdjustment * (1 - this.config.discount / 100);
          const priceDisplay = this.formatMoneyCountdown(price);

          buttonFirst.querySelector(".discounted-price").innerHTML = priceDisplay + "/un";
        } else {
          buttonsKits.push(button);
        }
      });

      buttonsKits.forEach((buttonKit) => {
        let discount = buttonKit.getAttribute("data-upsell-kits-discount");
        discount = discount * 0.01;

        const variantWithKitDiscount = variant.price - variant.price * discount;
        const variantWithAdjustment = this.priceAdjustment
          ? variantWithKitDiscount + this.priceAdjustment
          : variantWithKitDiscount;
        const variantWithCupomDiscount = variantWithAdjustment * (1 - this.config.discount / 100);

        const kitPriceMoney = this.formatMoneyCountdown(variantWithCupomDiscount);
        buttonKit.querySelector(".discounted-price").innerHTML = kitPriceMoney + "/un";
      });
    }
  }

  updatePriceTextKit(variant) {
    if (!variant || !variant.priceOriginal || !variant.priceDiscount) return;
    this.productPrice = variant.priceOriginal;

    if (this.config && this.config.message && this.config.discount && this.productPrice > 0) {
      const upsellButtons = this.discountedPrice.parentElement.parentElement.querySelectorAll(".upsell-kits__button");
      let buttonFirst,
        buttonsKits = [];

      upsellButtons.forEach((button, index) => {
        if (index === 0) {
          buttonFirst = button;

          const variantWithAdjustment = variant.priceAdjustment
            ? variant.priceOriginal + variant.priceAdjustment
            : variant.priceOriginal;

          const price = (variantWithAdjustment * (1 - this.config.discount / 100)) / variant.quantity;

          const priceDisplay = this.formatMoneyCountdown(price);

          buttonFirst.querySelector(".discounted-price").innerHTML = priceDisplay + "/un";
        } else {
          buttonsKits.push(button);
        }
      });

      buttonsKits.forEach((buttonKit) => {
        if (buttonsKits.length > 1) {
          let discount = buttonKit.getAttribute("data-upsell-kits-discount");
          discount = discount * 0.01;

          const variantPrice = variant.priceOriginal / variant.quantity;
          const variantWithKitDiscount = variantPrice - variantPrice * discount;
          const variantWithAdjustment = variant.priceAdjustment
            ? variantWithKitDiscount + variant.priceAdjustment
            : variantWithKitDiscount;
          const variantWithCupomDiscount = variantWithAdjustment * (1 - this.config.discount / 100);

          buttonKit.querySelector(".discounted-price").innerHTML =
            this.formatMoneyCountdown(variantWithCupomDiscount) + "/un";
        } else {
          buttonKit.querySelector(".discounted-price").innerHTML =
            this.formatMoneyCountdown(variant.priceDiscount * (1 - this.config.discount / 100)) + "/un";
        }
      });
    }
  }
}
customElements.define("cupom-kits-upsell", CupomKitUpsell);
